/**
 * Shared i18n helper functions for resolving locale-specific field values.
 * Used by server-side pages that fetch rooms with EN/RO/HU columns.
 */

export function localized(en: string, ro: string | null, hu: string | null, locale: string): string {
  if (locale === 'ro' && ro) return ro;
  if (locale === 'hu' && hu) return hu;
  return en;
}

export function localizedNullable(en: string | null, ro: string | null, hu: string | null, locale: string): string | null {
  if (locale === 'ro' && ro) return ro;
  if (locale === 'hu' && hu) return hu;
  return en;
}

/**
 * DP7 — maps our app locale to a BCP-47 tag for `Intl`/`toLocaleString` date
 * formatting, so a RO/HU surface gets month names in its own language instead of
 * a hardcoded English `en-US`/`en-GB`. English defaults to `en-GB` (day-month
 * order, the project's convention for an EU hotel).
 */
export function localeDateTag(locale: string): string {
  if (locale === 'ro') return 'ro-RO';
  if (locale === 'hu') return 'hu-HU';
  return 'en-GB';
}
